
// Custom authentication error class
export class AuthError extends Error {
  code: string;
  
  constructor(message: string, code: string = 'auth/unknown') {
    super(message);
    this.name = 'AuthError';
    this.code = code;
  }
}

// Standardized error handler
export const handleAuthError = (error: any): never => {
  console.error('Authentication operation failed:', error);
  
  let message = 'An unknown error occurred';
  let code = 'auth/unknown';
  
  if (error?.message) {
    message = error.message;
  }
  
  if (error?.code) {
    code = error.code;
  }

  // Log full error details in development
  if (process.env.NODE_ENV !== 'production') {
    console.error('Full auth error details:', JSON.stringify(error, null, 2));
  }
  
  throw new AuthError(message, code);
};
